require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.function.name");

/* eslint-disable no-underscore-dangle */
var EventEmitter = require('wolfy87-eventemitter');

var _require = require('phoenix'),
    Socket = _require.Socket;

var WebSocket = require('isomorphic-ws');

var debug = require('debug')(require('../package.json').name);

var EventClient = /*#__PURE__*/function () {
  "use strict";

  function EventClient(endpoint) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, EventClient);

    this.endpoint = endpoint;
    this.socket = null;
    this.subscriptions = {};
    this.channels = {};
    this.options = Object.assign({
      maxConnectionRetry: 4
    }, options);
    this.connectionRetry = 0;
  }

  _createClass(EventClient, [{
    key: "subscribe",
    value: function subscribe(topic, token) {
      var _this = this;

      var cacheKey = "".concat(topic, "-").concat(token);

      if (this.subscriptions[cacheKey]) {
        debug('subscribe.cached', {
          topic: topic,
          token: token
        });
        return Promise.resolve(this.subscriptions[cacheKey]);
      }

      debug('subscribe.do', {
        topic: topic,
        token: token
      });
      return new Promise(function (resolve, reject) {
        _this._ensureChanel(topic).then(function (channel) {
          channel.push("".concat(topic, ":subscribe"), {
            token: token
          }).receive('ok', function (res) {
            debug('subscribe success', {
              token: token,
              res: res
            });
            _this.subscriptions[cacheKey] = new EventEmitter();
            _this.subscriptions[cacheKey].id = cacheKey;

            _this.socket.onMessage(function (_ref) {
              var event = _ref.event,
                  payload = _ref.payload;

              if (event === "".concat(topic, ":data") && payload && payload.token) {
                debug("socket.onMessage.".concat(topic), {
                  event: event,
                  payload: payload
                });
                var subscription = _this.subscriptions[cacheKey];

                if (subscription) {
                  subscription.emit('data', payload);
                }
              }
            });

            resolve(_this.subscriptions[cacheKey]);
          }).receive('error', function (err) {
            debug('subscribe error: push', err);
            reject(err);
          });
        })["catch"](function (err) {
          debug('subscribe error: channel', err);
          reject(err);
        });
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(topic, token) {
      var _this2 = this;

      var cacheKey = "".concat(topic, "-").concat(token);

      if (!this.subscriptions[cacheKey]) {
        return Promise.resolve(true);
      }

      debug('unsubscribe.do', {
        topic: topic,
        token: token
      });
      return new Promise(function (resolve, reject) {
        _this2._ensureChanel(topic).then(function (channel) {
          channel.push("".concat(topic, ":unsubscribe"), {
            token: token
          }).receive('ok', function () {
            resolve(true);
          }).receive('error', function (err) {
            debug('unsubscribe error: push', err);
            reject(err);
          });
        })["catch"](function (err) {
          debug('unsubscribe error: channel', err);
          reject(err);
        });
      });
    }
  }, {
    key: "_ensureChanel",
    value: function _ensureChanel(topic) {
      var _this3 = this;

      var channel = this.channels[topic];

      if (channel && channel.isJoined()) {
        return Promise.resolve(channel);
      }

      this._ensureSocket();

      channel = this.socket.channel("".concat(topic, ":control"));
      return new Promise(function (resolve, reject) {
        channel.join().receive('ok', function (res) {
          debug('Channel join success', res);
          _this3.channels[topic] = channel;
          resolve(channel);
        }).receive('error', function (err) {
          debug('Channel join error', err);
          reject(err);
        });
      });
    }
  }, {
    key: "_ensureSocket",
    value: function _ensureSocket() {
      var _this4 = this;

      if (this.socket && this.socket.isConnected()) {
        return;
      }

      this.socket = new Socket(this.endpoint, {
        logger: debug,
        transport: WebSocket
      });
      this.socket.connect(); // auto reconnect on error

      this.socket.onError(function (err) {
        debug('socket.reconnect.onConnError', err);
        Object.keys(_this4.subscriptions).forEach(function (token) {
          _this4.subscriptions[token].emit('error', err);
        });

        if (_this4.connectionRetry >= _this4.options.maxConnectionRetry) {
          debug('connection retry reached');
          return;
        }

        _this4.connectionRetry += 1;
        setTimeout(function () {
          _this4.socket.connect();
        }, 1000);
      });
    }
  }]);

  return EventClient;
}();

module.exports = EventClient;